import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { authGuard } from './auth/auth.guard';
import { MainLayoutComponent } from './main-layout/main-layout.component';

export const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'cruds' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'cruds',
        loadComponent: () =>
          import('./crud-builder/crud-list.component').then((m) => m.CrudListComponent),
      },
      {
        path: 'marketplace',
        loadComponent: () =>
          import('./marketplace/marketplace-page.component').then((m) => m.MarketplacePageComponent),
      },
      {
        path: 'cruds/new',
        loadComponent: () =>
          import('./crud-builder/crud-builder.component').then((m) => m.CrudBuilderComponent),
      },
      {
        path: 'cruds/edit/:crudId',
        loadComponent: () =>
          import('./crud-builder/crud-builder.component').then((m) => m.CrudBuilderComponent),
      },
      {
        path: 'run/:crudId',
        loadComponent: () =>
          import('./run-crud/run-crud-view.component').then((m) => m.RunCrudViewComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
